import React, { useContext, useState, useEffect, useCallback, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { ANNUALLY, ConnectorContext, MONTHLY, UPDATE_BILLING_CYCLE } from '../index'
import PRODUCT_API, { cancelGetProduct } from '../../../utilities/api/product'
import {
  LOCALE_STRING_OPTIONS,
  LOCALE_LANG_OPTIONS
} from '../../../utilities/function/common'

import {
  getDataFromSuccessResponse,
  getErrorFromFailResponse
} from '../../../utilities/function/apiResponse'

import {
  getAttributes
} from '../../../utilities/function/configuration'

import {
  getDataFromURL
} from '../../../utilities/function/urlparams'

import {
  getCycle,
  getMonthlyPriceBasedOnOtherCycle,
  getPriceByBillingCycleID,
  getPriceByBillingCycleName
} from '../../../utilities/function/billingCycle'

import { useDispatch, useSelector } from 'react-redux'
import { updateConfig, addItemToCart } from '../../../app/action'
import Loading from '../../shared/loading'
import { cancelAddToExisting, cancelInitCart } from '../../../utilities/api/cart'

export const BILLING_CYCLE_CLASSNAME = 'of-webhosting-billing-cycle-connector'
export const BUTTON_CLASSNAME = 'of-webhosting-button-connector'
export const PRICE_CLASSNAME = 'of-webhosting-price-connector'

const WebHostingButton = (props) => {
  const {state} = useContext(ConnectorContext)
  const {label, PID, router, icon, container, promo, direct,config,addon,skipaddon} = props
  const {history} = router
  const appDispatch = useDispatch()
  const {configurations, cartStatus} = useSelector(state => ({
    configurations: state.app.configurations,
    cartStatus: state.app.cartStatus
  }))
  const [loadingStatus, setLoadingStatus] = useState({
    loadingStatus: false
  })
  const prevLoadingStatus = useRef(undefined)
  const resetStatusCallback = useCallback(() => {
    if (prevLoadingStatus.current !== cartStatus) {
      if (prevLoadingStatus.current === 'loading' && cartStatus === 'success' && loadingStatus !== false) {
        setLoadingStatus(false)
      }
      prevLoadingStatus.current = cartStatus
    }
  }, [cartStatus, loadingStatus, prevLoadingStatus])



  useEffect(() => {
    resetStatusCallback()
  }, [resetStatusCallback])
  const renderLoadingClass = () => {
    if (loadingStatus.PID === PID && (loadingStatus.loading || cartStatus === 'loading')) {
      return (` ${BUTTON_CLASSNAME}__button--loading`)
    }
    return ('')
  }
  const renderContent = () => {
    if (loadingStatus.PID === PID && (loadingStatus.loading || cartStatus === 'loading')) {
      return (
        <Loading className={`${BUTTON_CLASSNAME}__loading`}/>
      )
    }
    return (<>
      <span className={`${BUTTON_CLASSNAME}__label`}>{label}</span>
      {renderIcon()}
    </>)
  }
  const buttonOnClick = (e) => {
    e.preventDefault()
    const addConfigOptions = (data,values) => {
      let updated = values
      if(config){
        try {
          const configJSON = JSON.parse(config)
          if(configJSON && getAttributes(data)){
              const {config_options} = getAttributes(data)
              const selectedConfigOptions = []
              Object.keys(configJSON).forEach(key=>{
                if(config_options && config_options.length){
                  const currentConfig = config_options.find(i=>i.name===key)
                  if(currentConfig.options && currentConfig.options.length){
                    const currentOption = currentConfig.options.find(i=>i.name===configJSON[key])
                    if(currentOption){
                      selectedConfigOptions.push({
                        config_id: currentConfig.id,
                        option_id: currentOption.id
                      })
                    }
                  }
                }
              })
              updated = {
                ...updated,
                config: selectedConfigOptions
              }
          }
        }
        catch (e){
          console.log(e)
        }
      }
      return updated
    }
    const addSelectedAddon = (billing_cycle_id,values) => {
      if(addon && billing_cycle_id){
        let addonInput = addon.split["."]
        let addonOutput = []
        if(addonInput && Array.isArray(addonInput)){
          addonOutput = addonInput.map(id=>({id:parseInt(id), billing_cycle_id}))
        }else{
          addonOutput = [{
            id: parseInt(addon),
            billing_cycle_id
          }]
        }
        return ({
          ...values,
          addons: addonOutput
        })
      }
      return values
    }

    if (state && state.webHosting && (!loadingStatus.loading && cartStatus !== 'loading')) {
      const {billingCycle} = state.webHosting
      if (billingCycle && configurations && configurations[PID] && configurations[PID].selectedProduct && configurations[PID].selectedProduct.attributes) {
        const {price} = configurations[PID].selectedProduct.attributes
        const selectedPrice = getPriceByBillingCycleName(price, billingCycle)
        if (selectedPrice) {
          let conf = { billing_cycle_id: selectedPrice.billing_cycle_id}
          conf = addConfigOptions(configurations[PID].selectedProduct,conf)
          conf = addSelectedAddon(selectedPrice.billing_cycle_id,conf)
          updateConfig(configurations, PID, conf, appDispatch)
        }
        if (direct) {
          addItemToCart(configurations[PID], appDispatch, history, configurations)
        } else {
          history.push(`${history.location.pathname}?a=add&pid=${PID}${promo ? '&promo=' + promo : ''}${skipaddon || addon ?'&skipaddon=true':''}`)
        }
      } else {
        const refetchProduct = () => {
          if (cancelGetProduct) {
            cancelGetProduct()
          }
          if (cancelInitCart) {
            cancelInitCart()
          }
          if (cancelAddToExisting) {
            cancelAddToExisting()
          }
          if(direct){
            setLoadingStatus({
              PID,
              loading: true
            })
          }
          PRODUCT_API.getProduct([PID]).then(successresponse => {
            const data = getDataFromSuccessResponse(successresponse)
            if (data && data.length > 0 && data[0] && data[0].attributes) {
              const {price} = data[0].attributes
              const selectedPrice = getPriceByBillingCycleName(price, billingCycle)
              if (selectedPrice) {
                let conf = {
                  selectedProduct: data[0],
                  billing_cycle_id: selectedPrice.billing_cycle_id
                }
                conf = addConfigOptions(data[0],conf)
                conf = addSelectedAddon(selectedPrice.billing_cycle_id,conf)
                updateConfig(configurations, PID, conf, appDispatch)
              } else {
                const onetimePrice = getPriceByBillingCycleName(price, 'One Time')
                if (direct && onetimePrice) {
                  let conf = {
                    selectedProduct: data[0],
                    billing_cycle_id: onetimePrice.billing_cycle_id
                  }
                  conf = addConfigOptions(data[0],conf)
                  conf = addSelectedAddon(onetimePrice.billing_cycle_id,conf)
                  updateConfig(configurations, PID, conf, appDispatch)
                }
              }
              if (direct) {
                addItemToCart(configurations[PID], appDispatch, history, configurations)
              } else {
                history.push(`${history.location.pathname}?a=add&pid=${PID}${promo ? '&promo=' + promo : ''}${skipaddon || addon?'&skipaddon=true':''}`)
              }
            }
          }, () => {
            if(direct){
              setLoadingStatus({
                loading: false
              })
            }
          })
        }
        if (billingCycle && configurations[PID] === undefined) {
          refetchProduct()
        } else {
          //add a fallback if the localstorage is broken
          if (configurations[PID] && configurations[PID].selectedProduct && Array.isArray(configurations[PID].selectedProduct)) {
            refetchProduct()
          }
        }
      }
    }
  }
  const renderIcon = () => {
    if (icon) {
      return <i className={`${BUTTON_CLASSNAME}__icon icon-of-${icon}`}/>
    }
    return <></>
  }
  return (
    ReactDOM.createPortal(
      <div onClick={buttonOnClick}
           className={`${BUTTON_CLASSNAME}__button${!icon ? ' ' + BUTTON_CLASSNAME + '__button--no-icon' : ''}${renderLoadingClass()}`}>
        {renderContent()}
      </div>
      , container)
  )
}
WebHostingButton.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  align: PropTypes.string,
  router: PropTypes.any,
  PID: PropTypes.any,
  classList: PropTypes.any,
  inheritStyle: PropTypes.any
}

export const renderSaveMore = (item) => {
  if (item && item !== MONTHLY) {
    return (
      <div className={'of-save-more'}>
        <div className={'of-save-more__wrapper'}>
          Save More!
        </div>
        <div className={'of-save-more__triangle'}></div>
      </div>
    )
  }
  return (<></>)
}

const WebHostingBillingCycle = (props) => {
  const {list, container,isToggle,router,callback} = props
  const {state, dispatch} = useContext(ConnectorContext)
  const {configurations} = useSelector(state=>({
    configurations:state.app.configurations
  }))
  const urlParams = getDataFromURL(router.location.search)
  const {pid} = urlParams ? urlParams: {}
  const getCurrentBillingCycle = () => {
    if (state && state.webHosting && state.webHosting.billingCycle) {
      const {billingCycle} = state.webHosting
      return billingCycle
    }
    return null
  }
  const updateCycle = useCallback((cycle) => {
    const isUpdateValid = () => {
      if(isToggle){
        if(cycle === ANNUALLY || cycle === MONTHLY) return true
      }else{
        const string = list.split(',')
        if (string && string.length > 0 && string.find(i=>i===cycle)) return true
      }
      return false
    }
    if(isUpdateValid()){
      dispatch({
        type: UPDATE_BILLING_CYCLE,
        productType: 'webHosting',
        cycle
      })
      if(callback && typeof window[callback] === "function"){
        window[callback](cycle)
      }
    }
  },[dispatch,isToggle,list,callback])

  const renderRadioButton = () => {
    const renderList = () => {
      if (list) {
        const string = list.split(',')
        if (string && string.length > 0) {
          return string.map((item, index) => {
            return (
                <li key={index} className={`${BILLING_CYCLE_CLASSNAME}__item`} onClick={() => {
                  updateCycle(item)
                }}>
              <span
                  className={`${BILLING_CYCLE_CLASSNAME}__circle${item === getCurrentBillingCycle() ? ' selected' : ''}`}></span>
                  <label className={`${BILLING_CYCLE_CLASSNAME}__label`}>{item}</label>
                  {renderSaveMore(item)}
                </li>
            )
          })
        }
      }
      return (<></>)
    }
    return (
        <ul className={`${BILLING_CYCLE_CLASSNAME}__list`}>
          {renderList()}
        </ul>
    )
  }
  const prevBillingCycle = useRef(null)
  const stringConfiguration = JSON.stringify(configurations)
  const billingCycleChangeCallback = useCallback(()=>{
    const configurations = JSON.parse(stringConfiguration)
    if( pid && configurations[pid]
        && configurations[pid].billing_cycle_id
        && getAttributes(configurations[pid].selectedProduct)){
        const {price} = getAttributes(configurations[pid].selectedProduct)
        const billingCycle = getPriceByBillingCycleID(price,configurations[pid].billing_cycle_id)
        if(billingCycle && prevBillingCycle.current !== billingCycle.name){
          updateCycle(billingCycle.name)
          prevBillingCycle.current = billingCycle.name
        }
    }
  },[prevBillingCycle,pid,updateCycle,stringConfiguration])
  useEffect(()=>{
    billingCycleChangeCallback()
  },[billingCycleChangeCallback])

  const renderToggle = () => {
      const labelOnClick = (e,cycle) => {
        e.stopPropagation()
        updateCycle(cycle)
      }
    const wrapperOnClick = () => {
      const selected = getCurrentBillingCycle() === MONTHLY ?  ANNUALLY : MONTHLY
      updateCycle(selected)
    }
      return (<div className={`${BILLING_CYCLE_CLASSNAME}__toggle ${BILLING_CYCLE_CLASSNAME}-toggle${getCurrentBillingCycle()===ANNUALLY?' '
          + BILLING_CYCLE_CLASSNAME + '-toggle--toggled':''}`}>
        <div className={`${BILLING_CYCLE_CLASSNAME}-toggle__wrapper text-border-1-100`} onClick={wrapperOnClick}>
          <div onClick={e=>{labelOnClick(e,MONTHLY)}} className={`${BILLING_CYCLE_CLASSNAME}-toggle__label ${BILLING_CYCLE_CLASSNAME}-toggle__label--left${getCurrentBillingCycle()===MONTHLY?' text-font-1-100':' text-font-3-100'}`}>
            Pay Monthly
          </div>
          <div className={`${BILLING_CYCLE_CLASSNAME}-toggle__handle text-background-1-100`}></div>
          <div onClick={e=>{labelOnClick(e,ANNUALLY)}} className={`${BILLING_CYCLE_CLASSNAME}-toggle__label ${BILLING_CYCLE_CLASSNAME}-toggle__label--right${getCurrentBillingCycle()===ANNUALLY?' text-font-1-100':' text-font-3-100'}`}>
            Pay Yearly
          </div>
        </div>
      </div>)
  }

  const renderComponent = () => {
    if(isToggle){
      return renderToggle()
    }
    return renderRadioButton()
  }

  return (
    ReactDOM.createPortal(renderComponent(), container)
  )

}

WebHostingBillingCycle.propTypes = {
  list: PropTypes.any,
  container: PropTypes.any,
  isToggle: PropTypes.any,
  callback: PropTypes.any
}

const WebHostingPrice = (props) => {
  const {container, pid} = props
  const [requestProduct, setRequestProduct] = useState({})
  const {state} = useContext(ConnectorContext)
  const appDispatch = useDispatch()
  const getPriceFromBillingCycle = useCallback((price) => {
    if (state && state.webHosting) {
      const {billingCycle} = state.webHosting
      if (billingCycle && price && price.length) {
        return price.find(item => item.name === billingCycle)
      }
    }
    return null
  }, [state])

  const getProductName = () => {
    if (requestProduct && Array.isArray(getDataFromSuccessResponse(requestProduct)) && getDataFromSuccessResponse(requestProduct).length > 0) {
      const productList = getDataFromSuccessResponse(requestProduct)
      const product = productList[0]
      if (product && product.attributes) {
        const {name} = product.attributes
        return (<div className={PRICE_CLASSNAME + '__product-name'}>{name}</div>)
      }
    }
    return <></>
  }

  const renderPrice = (price, priceList) => {
    if (price && priceList) {
      const cycle = getCycle(price.name)
      if (price.name === MONTHLY && parseInt(price.price)) {
        const priceBasedOnCycle = getPriceByBillingCycleName(priceList, ANNUALLY)
        const renderInfo = () => {
          if (priceBasedOnCycle && parseFloat(priceBasedOnCycle.price)) {
            return (
              <div className={PRICE_CLASSNAME + '__wrapper'}>
                <div className={PRICE_CLASSNAME + '__info'}>
                  (${(parseFloat(priceBasedOnCycle.price) / 12).toLocaleString(LOCALE_LANG_OPTIONS, LOCALE_STRING_OPTIONS)} per
                  month if billed annually)
                </div>
              </div>
            )
          }
          return (<></>)
        }
        return (<>
            <div className={PRICE_CLASSNAME + '__wrapper'}>
              <div className={PRICE_CLASSNAME + '__product-name'}>
                {getProductName()}
              </div>
            </div>
            <div className={PRICE_CLASSNAME + '__wrapper'}>
              <div className={PRICE_CLASSNAME + '__current'}>
                <div className={PRICE_CLASSNAME + '__current-price'}>${parseInt(price.price)}</div>
                <div className={PRICE_CLASSNAME + '__current-cycle'}>{cycle}</div>
              </div>
            </div>
            {renderInfo()}
          </>
        )
      }
      const monthlyPriceBasenOnOtherCycle = getMonthlyPriceBasedOnOtherCycle(priceList, price.name)
      if (monthlyPriceBasenOnOtherCycle) {
        const monthlyPrice = getPriceByBillingCycleName(priceList, MONTHLY)
        const selectedPrice = getPriceByBillingCycleName(priceList, price.name)
        const renderInfo = () => {
          if (selectedPrice) {
            return (
              <div className={PRICE_CLASSNAME + '__wrapper'}>
                <div className={PRICE_CLASSNAME + '__info'}>
                  (billed at ${selectedPrice.price} <span>{selectedPrice.name}</span>)
                </div>
              </div>
            )
          }
          return (<></>)
        }
        return (
          <>
            <div className={PRICE_CLASSNAME + '__wrapper'}>
              <div className={PRICE_CLASSNAME + '__product-name'}>
                {getProductName()}
              </div>
            </div>
            <div className={PRICE_CLASSNAME + '__wrapper'}>
              <div className={PRICE_CLASSNAME + '__old'}>${parseInt(monthlyPrice.price)}</div>
              <div className={PRICE_CLASSNAME + '__current'}>
                <div className={PRICE_CLASSNAME + '__current-price'}>${monthlyPriceBasenOnOtherCycle.toFixed(2)}</div>
                <div className={PRICE_CLASSNAME + '__current-cycle'}>/mo</div>
              </div>
            </div>
            {renderInfo()}
          </>
        )
      }
    }
    return <></>
  }

  useEffect(() => {
    if (requestProduct.status === undefined) {
      setRequestProduct({
        ...requestProduct,
        status: 'loading'
      })
      PRODUCT_API.getProduct([pid]).then(successresponse => {
        const data = getDataFromSuccessResponse(successresponse)
        setRequestProduct({
          ...requestProduct,
          status: 'success',
          data
        })
      }, errorresponse => {
        const error = getErrorFromFailResponse(errorresponse)
        setRequestProduct({
          status: 'error',
          error
        })
      })
    }
  }, [requestProduct, pid, appDispatch])

  if (requestProduct.status === 'success' && requestProduct.data && requestProduct.data.length) {
    const product = requestProduct.data[0]
    if (product && product.attributes) {
      const {price} = product.attributes
      const selectedPrice = getPriceFromBillingCycle(price)
      return ReactDOM.createPortal(renderPrice(selectedPrice, price), container)
    }
  }

  return (<></>)
}
WebHostingPrice.propTypes = {
  container: PropTypes.any,
  pid: PropTypes.any
}

export const RenderWebHostingButtonConnector = ({router}) => {
  const buttonList = Array.from(document.querySelectorAll(`.${BUTTON_CLASSNAME}`))
  if (buttonList && buttonList.length) {
    return buttonList.map((el, index) => {
      const PID = parseInt(el.getAttribute('data-pid'))
      const label = el.getAttribute('data-label')
      const classList = el.classList
      const icon = el.getAttribute('data-icon')
      const promo = el.getAttribute('data-promo')
      const inheritStyle = el.getAttribute('inheritStyle')
      const direct = el.getAttribute('data-direct')
      const config = el.getAttribute('data-config')
      const addon = el.getAttribute('data-addon')
      const skipaddon = el.getAttribute('data-skipaddon')
      return (<WebHostingButton
            key={index}
            direct={direct}
            inheritStyle={inheritStyle}
            icon={icon}
            classList={classList}
            PID={PID}
            router={router}
            label={label}
            container={el}
            promo={promo}
            addon={addon}
            skipaddon={skipaddon}
            config={config}/>)
    })
  }
  return (<></>)
}
RenderWebHostingButtonConnector.propTypes = {
  router: PropTypes.any
}

export const RenderWebHostingBillingCycleConnector = ({router}) => {
  const domlist = Array.from(document.querySelectorAll(`.${BILLING_CYCLE_CLASSNAME}`))
  if (domlist && domlist.length) {
    return domlist.map((el, index) => {
      const string = el.getAttribute('data-list')
      const isToggle = el.getAttribute('data-isToggle')
      const callback = el.getAttribute('data-callback')
      return (<WebHostingBillingCycle router={router} key={index} container={el} list={string} isToggle={isToggle} callback={callback}/>)
    })
  }
  return (<></>)
}
RenderWebHostingBillingCycleConnector.propTypes = {
  router: PropTypes.any
}

export const RenderWebHostingPriceConnector = () => {
  const domlist = Array.from(document.querySelectorAll(`.${PRICE_CLASSNAME}`))
  if (domlist && domlist.length) {
    return domlist.map((el, index) => {
      const pid = el.getAttribute('data-pid')
      return (<WebHostingPrice key={index} container={el} pid={pid}/>)
    })
  }
  return (<></>)
}